// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from ".././config/colors";
import fonts from "../config/fonts";
const ProfileScreenStyle = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        paddingHorizontal: 10,
        backgroundColor: colors.green,
      },
      dataContainer: {
        width: '100%',
        height:'90%'
      },
      row: {
        flexDirection: 'row',
      },
      column: {
        flex: 1,
        marginRight: 10,
      },
      label: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 5,
        color: 'white',
        fontFamily: fonts.regular,
      },
      value: {
        color: 'white',
        fontSize: 16,
        marginBottom: 6,
        fontFamily: fonts.regular,
      },
});

export default ProfileScreenStyle;

